import Api from './coreapi';
export default {
    selectItemOnhand(filter){
        return new Promise((resolve) => {
            Api.request().post('item/onhands', filter).then(res => {
                if(Api.isValid(res)){
                    resolve(res.data);
                }
            });
        });
    }
}